<template>
  <div class='containerVue' >           
    <div class="row">   
        <div class="col-xs-12 col-md-2" >  
          <!--<router-link to='/' tag='a' ><div class='logo'>alanAutos <img v-bind:src="$http.options.root + '/images/carlogo.svg'" class="img-circle" alt="AlanAutos"></div></router-link>-->
          <router-link to='/' tag='a' ><div class='logoDiv'> <img class="logo" v-bind:src="$http.options.root + '/images/alan_auto_logo.jpg'"  alt="AlanAutos"></div></router-link>
        </div>
        <div class="col-xs-8 col-md-4" >  
          <ul class="nav nav-tabs">            
            <router-link to='/'         tag='li' active-class='active' exact><a class='customPadding'><i class="fa fa-home fa-2x" aria-hidden="true"></i>&nbsp;&nbsp;Portada</a></router-link>
            <router-link to='/contacto' tag='li' active-class='active'><a class='customPadding'><i class="fa fa-phone-square fa-2x" aria-hidden="true"></i>&nbsp;&nbsp;Contacto</a></router-link>                    
          </ul>
        </div>
        <div class="col-xs-4 col-md-4" > 
            <ul class="nav nav-tabs">              
              <router-link to='/membership/login'    tag='li' active-class='active'><a class='customPadding' ><i class="fa fa-user-o fa-2x" aria-hidden="true"></i>&nbsp;&nbsp;Mi Cuenta</a></router-link>       
              <li v-if='userInfo.username.length > 0' ><a class='customPadding'>{{ userInfo.username }}</a></li>
              <li v-if='userInfo.username.length > 0' ><Logout></Logout></li>
            </ul>   
        </div>          
    </div>
    <br>
    <div class="row">   
      <div class="col-xs-12 col-md-12" >  
        <AdminNav v-if='userInfo.isAdmin'> ></AdminNav>   
      </div>
    </div>    
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
      userInfo :{
          username:'',
          isLogged:0,
          isAdmin:0                
      }
    }
  },
  mounted: function () {        
    this.getUserInfo();
  },
  methods: {
    getUserInfo: function(){            

      this.$http.get('api/login').then(response => {                                                                  
        this.userInfo = response.body;
      }, response => {                  
        eventBus.$emit('errorMsg', response);          
      });
    },
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped> 

  .logoDiv {
    font-family: 'Faster One', cursive;
    color:#337ab7;   
    padding-top: 10px;
  }

  .logo{  
    height: 100px;
  }  

  @media screen and (max-width: 981px) {  
      .containerVue {        
        font-size: 2.4em;    
        margin-left:0px;        
      }

      .logoDiv {
        font-size: 2.5em;       
        width: 100%;
        text-align: center;
      }

      .logo{  
        height: 200px;
      }  

      .logo img {
        height: 100px;
      }

      
   }

  @media screen and (min-width: 981px) {          
      .containerVue {        
        font-size: 1.4em;            
      }

      .logo {
        font-size: 2.0em;       
        margin-left: 20px;    
        border-bottom: 1px solid #ddd;
      }

      .logo img {
        height: 75px;
      }

      .customPadding{ 
        padding: 25px 15px 22px;
      }
   }
</style>



// WEBPACK FOOTER //
// MainNav.vue?45076bee